/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługuje wszystko co jest związane z formularzem wyszukiwania w head
 *
 * @export
 * @class Search
 * @extends {SearchAutocomplete}
 */
import { SearchAutocomplete } from "./SearchAutocomplete.class";

export class Search extends SearchAutocomplete {
	constructor(options) {
		super();
		var defaults = {
			mainContID: null,
			searchInputID: null
		};
		this.settings = $.extend({}, defaults, options);
		this.searchCont = null;
		this.searchInput = null;
		this.mobileMenuSearchBtn = null;
		this.state = {
			advanceSearchShown: false,
			mobileMenuSearchPanelShown: false
		};
		this.advanceSearchTimer = false;
		this.canHideMobileSearchPanel = false;
		this.blockHidingMobileSearchPanelTime = 1000;
		this.blockHidingMobileSearchPanelTimer;
	}
	// ****************************************************************************************************
	// Inicjalizacja panelu search
	// ****************************************************************************************************
	init() {
		var that = this;
		that.searchCont = $('#' + that.settings.mainContID);
		that.searchInput = $('#' + that.settings.searchInputID);
		if (that.searchCont.length > 0) {
			if (pageObj.fixNaviStuckedElement) {
				pageObj.addFixNaviStuckedElement();
			}
			that.mobileMenuSearchBtn = $('#btnMenuSearchToggle');
			that.mobileMenuSearchBtn.on('click', function () {
				if ( NAV2023 ){
					$("#btnMenuMobile").trigger("click");
				} else {
					that.canHideMobileSearchPanel = true;
					if (that.state.mobileMenuSearchPanelShown) {
						that.hideMobileSearchPanel();
					}
					else {
						that.showMobileSearchPanel();
					}
				}
			});
			that.adjustFoundCategoriesToViewKind();
			that.initAdvanceSearch();
			that.initAutocomplete();
		}
	}
	// ****************************************************************************************************
	// Resetowanie panelu search w trybie MOBILE
	// ****************************************************************************************************
	blockHidingMobileSearchPanel() {
		var that = this;
		that.canHideMobileSearchPanel = false;
		clearTimeout(that.blockHidingMobileSearchPanelTimer);
		that.blockHidingMobileSearchPanelTimer = setTimeout(function () {
			that.canHideMobileSearchPanel = true;
		}, that.blockHidingMobileSearchPanelTime);
	}
	// ****************************************************************************************************
	// Pokazanie panelu search w trybie MOBILE
	// ****************************************************************************************************
	showMobileSearchPanel() {
		var that = this;
		//console.log('showMobileSearchPanel');
		if (!that.state.mobileMenuSearchPanelShown) { // musi byc powtorzenie wzgl init
			naviObj.hideMobileNavi();
			pageObj.scrollPageToNaviStuckState();
			that.blockHidingMobileSearchPanel();
			that.state.mobileMenuSearchPanelShown = true;
			that.mobileMenuSearchBtn.addClass('active');
			that.searchCont.slideDown(PRODUCTS_DETEILS_ANIMATION_SPEED, function () {
				that.searchInput.focus(); // nie dziala w IOS
				that.autocompleteUpdateBtnLeftPosition();
			});
		}
	}
	// ****************************************************************************************************
	// Ukrycie panelu search w trybie MOBILE
	// ****************************************************************************************************
	hideMobileSearchPanel() {
		var that = this;
		//console.log('hideMobileSearchPanel', pageObj.settings.bootstrap.kind);
		if (that.canHideMobileSearchPanel && that.state.mobileMenuSearchPanelShown && pageObj.settings.bootstrap.kind == 'mobile') { // musi byc powtorzenie wzgl init ORAZ ograniczenie tylko do mobile
			that.blockHidingMobileSearchPanel();
			that.state.mobileMenuSearchPanelShown = false;
			that.mobileMenuSearchBtn.removeClass('active');
			that.searchInput.blur();
			that.searchCont.slideUp(PRODUCTS_DETEILS_ANIMATION_SPEED, function () {
			});
		}
	}
	// ****************************************************************************************************
	// Update panelu advancesearch
	// ****************************************************************************************************
	updateAdvanceSearchPosition() {
		var that = this;
		//console.log('updateAdvanceSearchPosition');
		if (pageObj.settings.bootstrap.kind == 'mobile') {
			$('#advSearchDropdownMenu').css('max-height', function () {
				var maxH = pageObj.settings.device.initialHeight - $('#Search').height() - 10; //
				if (maxH < 150)
					maxH = 150;
				return maxH + 'px';
			});
		}
		else {
			$('#advSearchDropdownMenu').css('max-height', 'auto');
		}
	}
	// ****************************************************************************************************
	// Inicjalizacja panelu advancesearch
	// ****************************************************************************************************
	initAdvanceSearch() {
		var that = this;
		that.updateAdvanceSearchPosition();
		$('#btnAdvSearch').on('click', function (event) {
			if (pageObj.settings.device.initialHeight != $(window).height()) { // niweluje pojawiajaca sie klawiature na androidzi
				event.stopPropagation();
				setTimeout(function () {
					$('#btnAdvSearch').trigger('click');
				}, 500);
			}
			that.autocompleteHide();
		});
		$('.advSearchOption').on('click', function () {
			$('.advSearchOption').removeClass('selected');
			/*if ($('#kidInput').length > 0) {
				$('#kidInput').val($(this).data('kid'));
			} else {
				$('#searchForm').append('<input id="kidInput" name="kid" type="hidden" value="' + $(this).data('kid') + '" />');
			}*/
			if ($(this).data('kid') == "")
				$('#kidInput').remove();
			$('#searchForm').data('narrowedDownTo', $(this).data('kid'));
			$('#searchForm').attr("action", $(this).data('action'));
			$('#btnAdvSearchLabel').html($(this).data('input-txt'));
			$(this).addClass('selected');
			that.autocompleteUpdateBtnLeftPosition();
			that.autocompleteReloadSugestions();
			that.searchInput.focus();
		});
	}
	// ****************************************************************************************************
	// Responsywnosc - dostosowanie filtrowania
	// ****************************************************************************************************
	adjustFoundCategoriesToViewKind() {
		var that = this;
		var foundCategoriesCont = $('#searchedCategories');
		var desktopCont = $('#productsSidePanel');
		;
		var mobileCont = $('#mobileFoundCategoriesData');
		;
		if (pageObj.settings.bootstrap.kind == 'desktop') {
			$(desktopCont).append($(foundCategoriesCont));
		}
		else {
			$(mobileCont).append($(foundCategoriesCont));
		}
	}
}